import { render } from "./HoldOprettelseKvittering.vue?vue&type=template&id=c8307db2"
import script from "./HoldOprettelseKvittering.vue?vue&type=script&lang=js"
export * from "./HoldOprettelseKvittering.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__